"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectableFolders = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var sok_ui_1 = require("@caddigital/sok-ui");
var types_1 = require("@caddigital/sok-reducers/lib/types");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var GenericErrorMessage_1 = require("components/GenericErrorMessage");
var FolderTree_1 = require("components/FolderTree");
var dispatchers_1 = require("./utils/dispatchers");
var getState = function (state) { return state.vektorio.folderTree; };
var getLinkedFolders = function (state) { return state.vektorio.linkedFolders; };
var getIsLinkFoldersViewOpen = function (state) {
    return state.vektorio.linkFolders.isOpen;
};
var SelectableFolders = function (props) {
    var state = (0, react_redux_1.useSelector)(getState);
    var linkedFolders = (0, react_redux_1.useSelector)(getLinkedFolders);
    var isLinkFoldersViewOpen = (0, react_redux_1.useSelector)(getIsLinkFoldersViewOpen);
    var foldersToDisable = linkedFolders.linkedFolders.map(function (_a) {
        var folderId = _a.folderId;
        return Number(folderId);
    });
    var dispatchers = (0, dispatchers_1.mapDispatchers)((0, react_redux_1.useDispatch)());
    var fetchRoot = function () {
        if (isLinkFoldersViewOpen) {
            dispatchers.getContent({
                id: props.currentProject.rootFolder,
                name: (0, translation_1.getLocalization)('components/folderTreeNew/rootFolder'),
                uuid: props.currentProject.rootFolderIdentifier,
                project: props.currentProject.id,
                projectUuid: props.currentProject.uuid
            });
        }
    };
    React.useEffect(fetchRoot, [isLinkFoldersViewOpen]);
    var disableLinkedFolder = function (node) {
        var folderId = node.value.id;
        var isDisabled = foldersToDisable.includes(folderId);
        if (isDisabled) {
            node.selected = false;
            return {
                className: 'disabled',
                onClick: undefined
            };
        }
    };
    if (!state.data.tree && state.data.status === types_1.FETCHING) {
        return (React.createElement("div", { className: 'center' },
            React.createElement(sok_ui_1.LoadingSpinner, null)));
    }
    if (!state.data.tree && state.data.status === types_1.FAILED) {
        return (React.createElement("div", { className: 'center' },
            React.createElement(GenericErrorMessage_1.default, null,
                React.createElement(GenericErrorMessage_1.ErrorButton, { onClick: fetchRoot }))));
    }
    return state.data.tree ? (React.createElement(FolderTree_1.default, { parentIdentifier: props.currentProject.rootFolderIdentifier, tree: state.data.tree, showRoot: false, selectItem: dispatchers.selectItem, changeExpand: dispatchers.changeExpand, getContent: dispatchers.getContent, generateNodeProps: function (_a) {
            var node = _a.node;
            return disableLinkedFolder(node);
        } })) : null;
};
exports.SelectableFolders = SelectableFolders;
